import { b2x } from '@b2x/react/src';

import { Container } from '../Container';
import { GenericFormContentType } from '../contentTypes';
import { t } from '../i18n/i18n';
import { Page } from './Page';

export interface ForgotPasswordPageProps {}

export const ForgotPasswordPage = (props: ForgotPasswordPageProps) => {
  const content = b2x.useContent<GenericFormContentType>('FORGOT_PASSWORD_FORM_CONTENT');

  return (
    <Page grayBackground>
      <Container>
        <b2x.Row justifyContent={'center'}>
          <b2x.Col size={{ lg: 6, md: 8, xs: 12, xxl: 5 }}>
            <div className="mb-4">
              <h1 className="text-center mb-3 ">{b2x.formatHtml(content?.body.title)}</h1>
              <p>{b2x.formatHtml(content?.body.subTitle)} </p>
            </div>
            <b2x.ForgotPasswordFormHelper className="mb-4">
              {({ fieldsHelper }) => (
                <>
                  <b2x.FormGroup {...fieldsHelper.email.formGroup} label={t('form.loginForm.fields.username.label')}>
                    <b2x.TextInput {...fieldsHelper.email.textInput} />
                  </b2x.FormGroup>
                  <div className="d-grid">
                    <b2x.Button {...fieldsHelper.buttons.submit} />
                  </div>
                </>
              )}
            </b2x.ForgotPasswordFormHelper>
          </b2x.Col>
        </b2x.Row>
      </Container>
    </Page>
  );
};
